import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

/**
 * Shared shell for legal / informational pages (Privacy, Terms, Refunds,
 * Data Deletion, About, Contact). Keeps the same nav + footer + brand
 * typography as the homepage, just with a simpler single-column body so
 * these pages stay fast to write and easy to keep updated.
 *
 * Usage:
 * <LegalPageLayout eyebrow="Legal" title="Privacy Policy" updated="24 July 2026">
 *   <p>...</p>
 * </LegalPageLayout>
 */
export default function LegalPageLayout({ eyebrow, title, updated, children }) {
  return (
    <>
      <Navbar />

      <section className="px-6 pt-16 pb-10 md:px-12 md:pt-24">
        <div className="mx-auto max-w-3xl">
          {eyebrow && (
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-hotpink">
              {eyebrow}
            </p>
          )}
          <h1 className="mt-3 font-display text-4xl leading-[0.95] tracking-tighter md:text-6xl">
            {title}
          </h1>
          {updated && (
            <p className="mt-4 text-sm text-ink/50">Last updated: {updated}</p>
          )}
        </div>
      </section>

      <section className="px-6 pb-24 md:px-12">
        <div
          className="
            mx-auto max-w-3xl rounded-[2rem] border border-ink/10 bg-white
            p-8 md:p-12
            [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-black [&_h2]:tracking-tight [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:first:mt-0
            [&_h3]:font-display [&_h3]:text-lg [&_h3]:font-bold [&_h3]:mt-6 [&_h3]:mb-2
            [&_p]:text-ink/70 [&_p]:leading-relaxed [&_p]:mb-4
            [&_ul]:mb-4 [&_ul]:pl-5 [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:text-ink/70
            [&_li]:leading-relaxed
            [&_a]:text-hotpink [&_a]:font-semibold [&_a]:hover:underline
            [&_strong]:text-ink [&_strong]:font-semibold
          "
        >
          {children}
        </div>
      </section>

      <Footer />
    </>
  );
}
